import { toKebabCase } from '../utils/strings.js';
import { normalizeFieldErrors } from '../utils/objects.js';

/**
 * List of i18nKeys of authentication errors
 */

var i18nKeys = {
  generalUnknown: "errors.general.unknown",

  /**
   * @name playerLocked
   * @param {string} reason reason for lock
   * @returns {string} translation key with kebab case
   */
  playerLocked: reason => "errors.login.".concat(toKebabCase(reason)),
  invalidCredentials: "errors.login.invalid-credentials",
  invalidCountry: "errors.login.invalid-country"
};
/**
 * Exception for cases when player is locked
 *
 * @access public
 */

class LockedError extends Error {
  /**
   * @param {string} reason Reason that caused player to be locked
   */
  constructor(reason, expiresAt) {
    super(expiresAt ? "The player is locked for a reason: ".concat(reason, " and will be unlocked at ").concat(expiresAt, ".") : "The player is locked for a reason: ".concat(reason, "."));
    /**
     * @constant
     * @type {"LockedError"}
     */

    this.name = "LockedError";
    this.code = i18nKeys.playerLocked(reason);
    this.reason = reason;
    this.expiresAt = expiresAt;
  }

}
/**
 * Exception for cases when player is trying to authenticate with invalid credentials
 *
 * @access public
 */

class InvalidCredentialsError extends Error {
  /**
   * @param {string} statusCode Error status code
   */
  constructor(statusCode) {
    super("Invalid credentials");
    /**
     * @constant
     * @type {"InvalidCredentialsError"}
     */

    this.name = "InvalidCredentialsError";
    this.code = i18nKeys.invalidCredentials;
    this.status = statusCode;
  }

}
/**
 * Exception for general unknown cases
 *
 * @access public
 */

class GeneralUnknownError extends Error {
  /**
   * @param {string} statusCode Error status code
   */
  constructor(statusCode) {
    super("Authentication failed with status code ".concat(statusCode));
    /**
     * @constant
     * @type {"GeneralUnknownError"}
     */

    this.name = "GeneralUnknownError";
    this.code = i18nKeys.generalUnknown;
    this.statusCode = statusCode;
  }

}
/**
 * Exception for invalid country case
 *
 * @access public
 */

class InvalidCountryError extends Error {
  constructor() {
    super("Invalid country");
    /**
     * @constant
     * @type {"InvalidCountryError"}
     */

    this.name = "InvalidCountryError";
    this.code = i18nKeys.invalidCountry;
  }

}
/**
 * Exception for unprocessable entity
 *
 * @access public
 */

class UnprocessableEntityError extends Error {
  /**
   * @param {object} errors
   * @param {string | number} status
   */
  constructor(errors, status) {
    super("Unprocessable Entity");
    /**
     * @constant
     * @type {"UnprocessableEntityError"}
     */

    this.name = "UnprocessableEntityError";
    this.status = status;
    this.message = "Validation failed";
    this.errors = normalizeFieldErrors(errors);
  }

}

export { GeneralUnknownError, InvalidCountryError, InvalidCredentialsError, LockedError, UnprocessableEntityError };
